<style lang="sass" scoped>
.order-pay
    padding: 20px
    .pay-inter
        height: 40px
        line-height: 40px
        background: rgba(255,57,115,.1)
        color: #666
        text-align: center
        border-radius: 4px
        font-size: 16px
        span
            color: #FF3973
            font-weight: bold
            margin: 0 5px
    .pay-info
        padding: 20px
        text-align: center
        line-height: 1
        border-bottom: 1px solid #e9e9e9
        font-weight: 600
        font-size: 18px
        .left-right
            font-size: 14px
            margin: 20px 0 10px
    .pay-btm
        margin-top: 30px
        .pay-main
            border: 1px solid #e9e9e9
            border-radius: 0 4px 4px 4px
            padding: 20px
            .fee
                padding: 20px
                border: 2px solid #6296FF
                border-radius: 4px
                .all-fee, .fr
                    display: inline-block
                    margin-left: 20px
                    font-size: 16px
                    >span
                        margin-left: 5px
                        &.color
                            color: #FF7413
                    span
                        font-weight: 800
                        font-size: 14px
                        &.big
                            font-size: 20px

                .radio
                    position: relative
                    top: 5px

            .pay
                margin-top: 20px
                font-size: 18px
                .pswd-box
                    margin-top: 10px
                    width: 363px
                    position: relative
                    .no-click-cover
                        position: absolute
                        width: 100%
                        height: 60px
                        z-index: 1
                    .input
                        border: 1px solid #e9e9e9
                        width: 100%
                        height: 60px
                        line-height: 60px
                        position: relative
                        border-radius: 4px
                        .box
                            display: inline-block
                            width: 60px
                            height: 58px
                            border: 1px solid #fff
                            position: relative
                            &.cur
                                border: 1px solid #6296FF
                                .line
                                    background: #6296FF
                            .line
                                position: absolute
                                top: 14px
                                right: -1px
                                width: 1px
                                height: 30px
                                background: #e9e9e9
                        input
                            width: 58px
                            height: 100%
                            // margin-top: 15px
                            font-size: 30px
                            border: none
                            // border-right: 1px solid #e9e9e9
                            text-align: center
                            &:nth-of-type(6)
                                border-right: none

                    .pswd-btm
                        font-size: 14px
                        color: #999
                        margin-top: 10px
                        .fr
                            color: #6296FF
                            cursor: pointer

            .submit-btn
                margin: 30px 0

    .hidden-password-input
        position: absolute
        left: -9999px
        opacity: 0
        pointer-events: none
        width: 0
        height: 0

.fix-recharge
    .c
        text-align: center
        font-size: 16px
    img
        width: 60px
        margin-top: 25px
        margin-bottom: 10px
</style>

<template lang="pug">
main-right(:title="pageTitle")
    .order-pay
        .part-title 在线支付
        .pay-inter 如果在
            span {{leftTime}}
            | 内您无法完成支付，系统会将您的订单取消。
        .pay-info
            div 您的订单已成功，赶快去付款吧~
            div
                .left-right 您的订单号:
                    span {{orderInfo.orderCode}}
                .left-right 应付金额:
                    span(v-if="useFree") 0
                    span(v-else) {{orderInfo.amount ? orderInfo.amount.toFixed(2) : 0}}元
                .left-right.no-br 支付方式:
                    span(v-if="useFree") 会员权益
                    span(v-else) 账户余额

        .pay-btm
            .gg-tab.cur 余额支付
            .pay-main
                .fee
                    .radio
                        .radio-inner
                    template(v-if="useFree")
                        .all-fee 会员免费点位剩余
                            span.Akrobat-ExtraBold {{vipPointRemain}}个
                        .fr 支付
                            span.color.Akrobat-ExtraBold {{orderInfo.vipReduce || 0}}个
                    template(v-else)
                        .all-fee 账户余额
                            span.Akrobat-ExtraBold ￥
                                span.big {{normalFee | fmtFee}}
                                | .{{normalFee | fmtFee(1)}}
                        .fr 支付
                            span.color.Akrobat-ExtraBold ￥
                                span.big {{orderInfo.amount | fmtFee}}
                                | .{{orderInfo.amount | fmtFee(1)}}

                .pay
                    | 账号支付密码
                    // 隐藏的假密码输入框，用于防止浏览器自动填充
                    input.hidden-password-input(
                        type="password"
                        autocomplete="new-password"
                        tabindex="-1"
                        style="position: absolute; left: -9999px; opacity: 0;"
                    )
                    .pswd-box
                        .no-click-cover
                        .input(@click="inputClick")
                            .box(v-for="(item, i) in 6" :key="i" :class="{'cur': pwdInputIdx == i}")
                                input(
                                    ref="payInput"
                                    autocomplete="one-time-code"
                                    data-form-type="other"
                                    data-lpignore="true"
                                    maxlength="1"
                                    :value="password[i] || ''"
                                    @focus="handleInputFocus(i)"
                                    @input="(e) => { handleInput(e, i) }"
                                    @keydown="(e) => { pwdChange(e, i) }"
                                    @paste.prevent="handlePaste"
                                    type="password"
                                )
                                .line(v-if="i<5")
                        .pswd-btm 输入6位数字密码
                            .fr(@click="goUrl('/modifyPassword', { type: 2 })") 忘记密码

                .submit-btn(@click="payAction") 确认付款

        fix-center.fix-recharge(ref="recharge" w="400" h="300")
            template(slot="title") 温馨提醒
            .c(slot="main")
                img(src="../../assets/icon-fee-short.png")
                div 您的支付余额不足，快去充值~
            template(slot="btm")
                .fix-btn.red(@click="goUrl('/recharge')") 去充值
                .fix-btn(@click="$refs.recharge.hide()") 取消

        fix-center.fix-recharge(ref="setPwd" w="400" h="300")
            template(slot="title") 温馨提醒
            .c(slot="main")
                img(src="../../assets/icon-fee-short.png")
                div 您还未设置支付密码，请设置后再支付订单
            template(slot="btm")
                .fix-btn.red(@click="goUrl('/modifyPassword', { type: 2, payRedirect: '/orderPay', orderId: $route.query.id })") 前往设置
                .fix-btn(@click="$refs.setPwd.hide()") 取消

</template>

<script>
import { mapGetters } from 'vuex'
import { getOrderDetail, orderPayment } from "@/utils/api"

export default {
    name: 'OrderPay',
    data(){
        let query = this.$route.query
        return {
            useFree: query.freeMark && query.freeMark == 1, // 是否使用会员权益支付
            amount: 0,
            password: [],
            pwdInputIdx: 0,
            leftSeconds: 30 * 60 - 1,
            isPaying: false,
            timeInterval: null,
            orderFrom: this.$route.query.from || 'map',
            pageTitle: this.orderFrom === 'map' ? '地图投放' : '智能快速发布',
            orderInfo: {}
        }
    },
    computed: {
        leftTime () {
            let time = this.leftSeconds
            let h = Math.floor(time / 3600)
            let m = Math.floor(time % 3600 / 60)
            let s = time % 60
            return add0(h) + '时' + add0(m) + '分' + add0(s) + '秒'
            function add0 (t) {
                return t - 0 < 10 ? '0' + t : t
            }
            // let s = time % 60 > 9 ? time % 60 : '0'+ time % 60
            // return Math.floor(time / 60) + '分' + s + '秒'
        },
        ...mapGetters('customer', {
            vipPointRemain: 'vipFreeRemain',
            normalFee: 'normalFee', // 普通账户总余额
            hasPayPwd: 'hasPayPwd',
        })
    },
    beforeDestroy () {
        window.clearInterval(this.timeInterval)
        document.body.removeEventListener('click', this.inputFocus, false)
    },
    watch: {
        hasPayPwd: {
            immediate: true,
            handler (v) {
                this.$nextTick(() => {
                    let refPwd = this.$refs.setPwd
                    if (refPwd) {
                        if (!v) refPwd.show()
                        else refPwd.hide()
                    }
                })
            }
        }
    },
    async created() {
        // 会员权益
        this.$store.dispatch('order/getPayWay')
        // 订单信息以及倒计时相关数据
        let data = await getOrderDetail({guid: this.$route.query.id})
        if (data && data.code == this.successCode && data.data) {
            let obj = data.data
            this.orderInfo = obj
            this.leftSeconds = obj.valiPeriodSec || 0
        } else {
            this.messageTip(data && data.msg || '获取订单信息异常，请稍后刷新重试')
        }
        // 账户余额
        await this.$store.dispatch('customer/getAccBalance')
    },
    mounted () {
        this.timeInterval = setInterval(()=>{
            if (this.leftSeconds > 0) {
                this.leftSeconds--
            } else {
                clearInterval(this.timeInterval)
                this.goUrl('/orderList')
            }
        }, 1000)


        // 延迟初始化，避免浏览器自动填充
        this.$nextTick(() => {
            const to = setTimeout(() => {
                clearTimeout(to)
                if (this.$route.path == '/orderPay') {
                    // 先清空所有输入框，防止自动填充
                    if (this.$refs.payInput) {
                        this.$refs.payInput.forEach((input, index) => {
                            if (input) {
                                input.value = ''
                                this.$set(this.password, index, '')
                            }
                        })
                    }
                    this.pwdInputIdx = 0
                    this.$nextTick(() => {
                        if (this.$refs.payInput && this.$refs.payInput[0]) {
                            // 使用 setTimeout 进一步延迟，确保浏览器不会自动填充
                            setTimeout(() => {
                                this.$refs.payInput[0].focus()
                            }, 100)
                        }
                    })
                    document.body.addEventListener('click', this.inputFocus, false)
                }
                this.handleshowCharge()
            }, 500)
        })
    },
    methods: {
        handleshowCharge () {
            if (this.normalFee - this.orderInfo.amount < 0) { // 余额不足
                this.$refs.recharge.show()
                return true
            }
            return false
        },
        inputFocus () {
            if (this.$refs.payInput && this.$refs.payInput[this.pwdInputIdx]) {
                this.$refs.payInput[this.pwdInputIdx].focus()
            }
        },
        inputClick () {
            // 点击密码框区域时，聚焦到当前应该输入的输入框
            if (this.$refs.payInput && this.$refs.payInput[this.pwdInputIdx]) {
                this.$refs.payInput[this.pwdInputIdx].focus()
            }
        },
        handleInputFocus (i) {
            // 处理输入框获得焦点，更新当前输入索引
            this.pwdInputIdx = i
        },
        handleInput (e, i) {
            // 处理输入事件，确保只输入数字
            let value = e.target.value

            // 只保留数字，并只取最后一个字符（防止粘贴多个字符或浏览器追加）
            const digits = value.replace(/[^\d]/g, '')
            value = digits.slice(-1) // 只取最后一个数字字符

            // 如果输入框的值长度大于1，说明可能是浏览器追加了，需要清空重新设置
            if (e.target.value.length > 1) {
                e.target.value = value
            }

            // 如果值没有变化，直接返回，避免重复处理
            if (this.password[i] === value) {
                return
            }

            // 更新密码数组
            this.$set(this.password, i, value)

            // 确保输入框显示的值正确（只显示一个字符）
            if (e.target.value !== value) {
                e.target.value = value
            }

            // 如果输入了有效数字，延迟聚焦到下一个输入框
            if (value && i < 5) {
                // 使用 setTimeout 确保在浏览器完成输入后再切换焦点
                setTimeout(() => {
                    if (this.$refs.payInput && this.$refs.payInput[i + 1]) {
                        this.pwdInputIdx = i + 1
                        // 确保下一个输入框为空，防止浏览器自动填充
                        if (this.$refs.payInput[i + 1].value) {
                            this.$refs.payInput[i + 1].value = ''
                            this.$set(this.password, i + 1, '')
                        }
                        this.$refs.payInput[i + 1].focus()
                    }
                }, 30)
            }
        },
        handlePaste (e) {
            // 阻止粘贴，因为这是6位密码输入，不应该允许粘贴
            e.preventDefault()
            this.messageTip('为了安全，请手动输入密码')
        },
        pwdChange(e, i) {
            // 处理键盘事件
            let code = e.keyCode || e.which

            // 退格键处理
            if (code == 8) {
                e.preventDefault()
                e.stopPropagation() // 阻止事件冒泡，避免全局监听器也处理
                // 如果当前输入框有值，清空当前输入框
                if (this.password[i]) {
                    this.$set(this.password, i, '')
                    e.target.value = ''
                } else {
                    // 如果当前输入框为空，清空上一个输入框并聚焦
                    if (i > 0) {
                        this.$set(this.password, i - 1, '')
                        this.$nextTick(() => {
                            this.pwdInputIdx = i - 1
                            if (this.$refs.payInput && this.$refs.payInput[i - 1]) {
                                this.$refs.payInput[i - 1].value = ''
                                this.$refs.payInput[i - 1].focus()
                            }
                        })
                    }
                }
                return
            }

            // 允许数字键（0-9）和小键盘数字键（0-9），不阻止，让浏览器正常输入
            const isNumberKey = (code >= 48 && code <= 57) || (code >= 96 && code <= 105)
            if (isNumberKey) {
                // 数字键完全交给浏览器和 handleInput 处理
                // 如果当前输入框已有值，在 handleInput 中会处理替换逻辑
                return
            }

            // 阻止其他按键（非数字、非退格）
            e.preventDefault()
            e.stopPropagation()
        },
        async payAction () {
            if (this.password.filter(el => el).length == 0) return this.messageTip('请输入支付密码')
            else if (this.password.filter(el => el).length < 6) return this.messageTip('支付密码不正确')
            if (this.handleshowCharge()) return
            if (this.isPaying) return
            this.isPaying = true
            // 更新用户数据
            if (!this.hasPayPwd) await this.$store.dispatch('customer/getUserInfo')
            this.$nextTick(async () => {
                if(!this.hasPayPwd) { // 未设置支付密码
                    this.$refs.setPwd.show()
                    this.isPaying = false
                    return
                }

                const param = await this.encryptorProto({ payPassword: this.password.join('') })
                if (param) {
                    const res = await orderPayment(this.orderInfo.guid, param)
                    this.isPaying = false
                    if (res) {
                        if (res.code == this.successCode) {
                            tzx_czcPush('payOrder', 1)
                            this.$store.dispatch('orderSum', { orderStatusList: '3,4' }) // 更新导航上部点位数
                            this.$store.dispatch('customer/getAccBalance') // 更新余额
                            this.$store.dispatch('customer/getCustomerInfo') // 更新客户信息中的会员限免点位额度
                            this.$store.dispatch('order/getPayWay') // 更新会员权益
                            this.goUrl('/payOk', { orderId: this.orderInfo.guid, from: this.orderFrom, isPkg: this.$route.query.isPkg || '' })
                        } else if (res.code == 90003003) { // 余额不足
                            tzx_czcPush('payOrder', 0)
                            this.$refs.recharge.show()
                        }
                    } else {
                        tzx_czcPush('payOrder', 0)
                        this.messageTip(res.msg || '操作失败')
                    }
                } else {
                    this.isPaying = false
                }
            })
        }
    }
}
</script>


